import React from 'react'
import { Badge, Tag } from 'antd'
import type { ConnectorStatus } from '../types'

interface Props {
  status: ConnectorStatus['status']
}

const STATUS_MAP: Record<ConnectorStatus['status'], { color: string; text: string }> = {
  connected: { color: 'success', text: 'Connected' },
  configured: { color: 'processing', text: 'Configured' },
  error: { color: 'error', text: 'Error' },
  unconfigured: { color: 'default', text: 'Not Configured' },
}

const ConnectorStatusBadge: React.FC<Props> = ({ status }) => {
  const info = STATUS_MAP[status] || STATUS_MAP.unconfigured
  return <Tag color={info.color}>{info.text}</Tag>
}

export default ConnectorStatusBadge
